import {
  Button,
  Icon,
  InputGroup,
  InputLeftAddon,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  Textarea,
} from '@chakra-ui/react'
import { memo } from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import { BiDotsHorizontalRounded } from 'react-icons/bi'

export const ViewDescriptionModal = memo(
  ({ description, handleDescription, isOpen, onOpen, onClose, onConfirm }) => {
    return (
      <>
        <InputGroup>
          <InputLeftAddon
            children="DESCRIÇÃO"
            fontSize="14px"
            width="122px"
            borderColor={'#C5CED6'}
          />
          <Button
            borderLeftRadius={0}
            borderRightRadius="md"
            bg="transparent"
            w="100%"
            border="1px solid #378BBF"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            onClick={onOpen}
            borderColor={'#378BBF'}
            overflow={'hidden'}
          >
            <Text fontSize="sm" mr="auto">
              {description.current}
            </Text>
            <Icon
              as={BiDotsHorizontalRounded}
              fontSize="30px"
              color="#378BBF"
            />
          </Button>
        </InputGroup>

        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent maxW="570px" w="full">
            <ModalBody>
              <Textarea
                defaultValue={description.current}
                resize="none"
                rows={7}
                mt="10px"
                placeholder="Descrição"
                fontSize="14px"
                onChange={(e) => handleDescription(e.target.value)}
              />
            </ModalBody>

            <ModalFooter maxW="740px" w="full" mx="auto" position="relative">
              <Button
                mr="auto"
                onClick={onClose}
                border={0}
                bg="transparent"
                fontSize="20px"
              >
                <Icon as={AiOutlineCloseCircle} w="20px" h="20px" mr=".5rem" />
                Cancelar
              </Button>
              <Button
                colorScheme="blue"
                maxW="295px"
                w="full"
                rounded={'full'}
                onClick={onConfirm}
              >
                Confirmar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    )
  }
)
